// AutomationRuleEditor.jsx

import React from 'react';

// Components
import AutomationRule from './rule/AutomationRule';

/**
 * AutomationRuleEditor
 *
 * Shared embedded body for editing a single automation rule.
 *
 * @returns {ReactNode} The rendered component.
 */
const AutomationRuleEditor = ({
  allowCollapse = false,
  allowEmailActions = true,
  draftRule,
  fieldEnumOptionsByKey,
  fieldOptions,
  fieldTypeByKey,
  handleAddAction,
  handleAddCondition,
  handleRemoveAction,
  handleRemoveCondition,
  handleRemoveRule = () => {},
  nodeTypeOptions = [],
  ruleFieldOptions,
  showHeader = false,
  showRemoveButton = false,
  updateConditionRows,
  updateRule,
  width = '100%',
  baseKey = '',
}) => {

  if (!draftRule) return null;

  // ----- RENDER ----- //

  return (
    <div
      className="automation-rule-editor"
      style={{
        maxWidth: '100%',
        width,
      }}
    >
      <AutomationRule
        allowCollapse={allowCollapse}
        allowEmailActions={allowEmailActions}
        fieldEnumOptionsByKey={fieldEnumOptionsByKey}
        fieldOptions={fieldOptions}
        fieldTypeByKey={fieldTypeByKey}
        handleAddAction={handleAddAction}
        handleAddCondition={handleAddCondition}
        handleRemoveAction={handleRemoveAction}
        handleRemoveCondition={handleRemoveCondition}
        handleRemoveRule={handleRemoveRule}
        index={0}
        nodeTypeOptions={nodeTypeOptions}
        rule={draftRule}
        ruleFieldOptions={ruleFieldOptions}
        showHeader={showHeader}
        showRemoveButton={showRemoveButton}
        updateConditionRows={updateConditionRows}
        updateRule={updateRule}
        baseKey={baseKey}
      />
    </div>
  );
};

// Dev Tools
AutomationRuleEditor.displayName = 'AutomationRuleEditor';

export default AutomationRuleEditor;
